var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StaffManagement"},[_c('a-button-group',{staticStyle:{"margin-top":"10px"}},[_c('a-button',{class:_vm.index == 1 ? 'ant-btn-primary' : '',on:{"click":function($event){return _vm.routerBtn(1)}}},[_vm._v("员工管理")]),_c('a-button',{class:_vm.index == 2 ? 'ant-btn-primary' : '',on:{"click":function($event){return _vm.routerBtn(2)}}},[_vm._v("离职管理")]),_c('a-button',{class:_vm.index == 3 ? 'ant-btn-primary' : '',on:{"click":function($event){return _vm.routerBtn(3)}}},[_vm._v("员工合同管理")])],1),_c('div',{style:({
      'border-top': '1px solid #E0E1E2',
      'margin-top': '-1px',
      'min-height': _vm.clientH
    })},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }